import React from 'react';
import { withStyles, Box } from '@material-ui/core';
import { ADGMPanel } from 'aurora-components';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { keyEmptyCheck, formatCurrencyWithoutCurrency } from 'aurora-utils/utils';
import styles from './styles';

function AuthorityFees({ classes, municipalityCharges }) {
  if (!municipalityCharges) return null;
  return (
    <>
      <ADGMPanel
        title='adgm_authority_fees'
        classes={{
          titleHead: classes.titleHead,
          panelContainer: classes.panelContainer,
        }}
      >
        <Box className={classes.sectionBox}>
          <div className={classNames(classes.paymentDetailItemContainer, classes.totalPaymentDetailItemContainer)}>
            <div className={classes.totalPaymentDetailItem}>
              {keyEmptyCheck('five_percent_of_total_agreement_amount')}
              <span>
                {keyEmptyCheck('AED_amount', {
                  num: formatCurrencyWithoutCurrency(municipalityCharges),
                })}
              </span>
            </div>
          </div>
        </Box>
      </ADGMPanel>
    </>
  );
}

AuthorityFees.propTypes = {
  classes: PropTypes.object.isRequired,
  municipalityCharges: PropTypes.object.isRequired,
};
export default withStyles(styles)(injectIntl(AuthorityFees));
